module.exports = __webpack_public_path__ + "img/photo.40b92068.jpg";